import classNames from 'classnames'

import { T, useTranslate } from 'lib/tolgee'
import { numberUtils, TOLGEE_GLOBALS } from 'utils'

const TOLGEE_PREFIX = 'VideoCardList-LivePostMetric'
const LIVE_METRIC_TRANSLATION = {
  finished: TOLGEE_GLOBALS.views,
  inProgress: TOLGEE_GLOBALS.views,
  scheduled: TOLGEE_GLOBALS.waiting,
}

function LivePostMetric({ live, views }) {
  const t = useTranslate()

  if (!live) {
    return null
  }

  function getMetric() {
    if (live?.state === 'finished') {
      return views
    }

    return live?.performance?.[lastPerformanceIndex]?.concurrentViewers
  }

  const metricTranslation = LIVE_METRIC_TRANSLATION?.[live?.state]
  const isScheduled = live?.state === 'scheduled'
  const lastPerformanceIndex = live?.performance?.length - 1
  const watchingMetric = getMetric()

  return (
    <div
      className={classNames('VideoCardList-views', {
        'tooltipped tooltipped-multiline tooltipped-n': isScheduled,
      })}
      aria-label={t({
        key: `${TOLGEE_PREFIX}-warningTooltip`,
        defaultValue: 'The number of people watching will be available here once the live starts.',
      })}
    >
      {isScheduled ? '--' : numberUtils.format(watchingMetric, 1)}

      <div className="VideoCardList-metric-label">
        <T keyName={metricTranslation.key}>{metricTranslation.defaultValue}</T>
      </div>
    </div>
  )
}

export default LivePostMetric
